export default [
  {
    path: '/attendances',
    component: () => import(/* webpackChunkName: "attendances" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
  {
    path: '/attendances/hospitalizations',
    component: () => import(/* webpackChunkName: "attendances" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
  {
    path: '/attendances/hospitalizations/:patientId',
    component: () => import(/* webpackChunkName: "attendances" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
    },
  },
];
